import { expected, isUndefined } from '@aloft/toolkit-shared';

import { useEffect } from 'react';
import { useParams } from 'react-router';

import { LoadingScreenSamFull } from '../../components/LoadingScreen/LoadingScreenSamFull.tsx';
import { usePrefillOrder } from '../../modules/orderManagement/hooks/usePrefillOrder.ts';
import { useOrderStatusGuard } from '../hooks/useOrderStatusGuard.tsx';

const creationLoadingMessages = [
  { breakpoint: 0.04, message: 'Fetching property data from multiple sources' },
  { breakpoint: 0.22, message: 'Analyzing quality & condition' },
  { breakpoint: 0.41, message: 'Calculating replacement cost' },
  { breakpoint: 0.64, message: 'Subtracting depreciation' },
  { breakpoint: 0.74, message: 'Extracting site values' },
  { breakpoint: 0.9, message: 'Calculating adjustments and cost approach' },
];

export const PrepareOrderElement = () => {
  const { orderId } = useParams();
  const orderID = expected(orderId);
  const { order, orderStatusModal } = useOrderStatusGuard(orderID);
  const prefillOrder = usePrefillOrder();

  useEffect(() => {
    if (order.data?.requiresPrefill) {
      prefillOrder(order.data)
        .then(() => {
          window.location.href = `/order/${orderID}/paired-cost/details`;
        })
        .catch((e) => {
          throw new Error(`Failed to prefill order: ${e.message}`);
        });
    }
  }, [order.data?.requiresPrefill]);

  if (order.data === null || isUndefined(order.data)) {
    return null;
  }

  if (!order.data.requiresPrefill) {
    window.location.href = `/order/${orderID}/paired-cost/details`;
    return null;
  }

  return (
    <>
      <LoadingScreenSamFull
        isLoading
        what="Order"
        wrapperProps={{ backgroundColor: 'surface1' }}
        longLoaderProps={{
          estimatedDurationSeconds: 8,
          messageBreakpoints: creationLoadingMessages,
        }}
      />
      {orderStatusModal}
    </>
  );
};
